import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-2 relative next-table-tooltip" }
const _hoisted_2 = { class: "truncate" }
const _hoisted_3 = { class: "hidden absolute inset-0 w-full border-next-gray-md pb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(["px-2 bg-next-gray-md rounded outline outline-1 z-10 shadow", _ctx.inner_class])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ])
  ]))
}